import React from 'react';
import { Text, Input, TextArea, DatePicker } from 'components/tt-forms/common';
import {validatable} from 'components/utils';
import { ThanhTra } from 'api';
import {ShowIf} from 'components/utils';
import { connect } from 'react-redux';
import { ContainerFileDinhKem } from 'components/upload';
import moment from 'moment';
import {get, isEmpty} from 'lodash';

class ThongTinChung extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      ngayRaQuyetDinh: '',
      namThanhTraList: [],
      namThanhTra: '',
      quyetDinhPheDuyetKTTT: '',
      chucNangKeHoachThanhTra: '',
      nguoiKy: '',
      ghiChu: '',
      listTaiLieuVanThuThayTheCTT: [],
      soVanBanDieuChinh: '',
      ngayQuyetDinhDieuChinh: '',
      lyDoDieuChinh: ''
    }
  }

  componentDidMount() {
    this.getNamThanhTraList();
    this.getDetails(this.props.bindValidator.props.params.id);
  }

  getDetails(idKH) {
    ThanhTra.actions.getKeHoachThanhTraDetail.request({id: idKH}).then(res => {
      if (!isEmpty(res.data)) {
        let data = res.data;
        this.setState({
          listTaiLieuVanThuThayTheCTT: data.listVanBanDieuChinh || [],
          soVanBanDieuChinh: data.soVanBanDieuChinh || '',
          ngayQuyetDinhDieuChinh: data.ngayQuyetDinhDieuChinh ? new Date(data.ngayQuyetDinhDieuChinh) : '',
          lyDoDieuChinh: data.lyDoDieuChinh || ''
        },() => {
          this.checkFileRequire();
        });
      }
    });
  }

  checkFileRequire() {
    let dataTaiLieuVanThu = [...this.state.listTaiLieuVanThuThayTheCTT];
    let dataTaiLieuVanThuFilter = dataTaiLieuVanThu.filter(taiLieu => get(taiLieu, 'loaiQuyTrinh') === 'DIEU_CHINH_KE_HOACH_THANH_TRA');
    if (isEmpty(dataTaiLieuVanThuFilter)) {
      let newItem = {
        ten: 'Văn bản điều chỉnh',
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        phanLoaiQuyTrinh: 'DIEU_CHINH_KE_HOACH_THANH_TRA',
        loaiQuyTrinh: 'DIEU_CHINH_KE_HOACH_THANH_TRA',
        newFile: true,
        typeRequired: 'VBDC'
      };
      this.setState({
        listTaiLieuVanThuThayTheCTT: [
          ...this.state.listTaiLieuVanThuThayTheCTT,
          newItem
        ]
      });
    }
  }

  getNamThanhTraList() {
    if (this.props.namThanhTra.length === 0) {
      ThanhTra.actions.getNamThanhTra.request().then(res => {
        if (res.data) {
          this.props.dispatch({type:'SET_NAM_THANH_TRA', data: res.data});
        }
      });
    }
  }

  onFileChangeDK(data, type) {
    this.props.onFileChange(data, type);
    this.updateData();
  }

  onFileRemove(id, data, type) {
    this.props.onFileRemove(id, data, type)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data != nextProps.data) {
      this.state.namThanhTra = nextProps.data.namThanhTra || '';
      this.state.quyetDinhPheDuyetKTTT = nextProps.data.quyetDinhPheDuyetKTTT || '';
      this.state.ngayRaQuyetDinh = nextProps.data.ngayRaQuyetDinh ? new Date(nextProps.data.ngayRaQuyetDinh) : '';
      this.state.chucNangKeHoachThanhTra = nextProps.data.chucNangKeHoachThanhTra || '';
      this.state.nguoiKy = nextProps.data.nguoiKy || '';
      this.state.ghiChu = nextProps.data.ghiChu || '';
      this.setState({...this.state});
    }

    if (this.props.tabType != nextProps.tabType) {
      this.updateData(nextProps.tabType, true);
    }
  }

  updateData(newType, isInit) {
    let type = newType || this.props.tabType;
    if (type == 'old') {
      this.props.onChangeBS(this.state, isInit);
    } else {
      this.props.onChange(this.state);
    }
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    }, () => {
      this.updateData();
    });
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      }, () => {
        this.updateData();
      });
    } else {
      this.setState({
        [name]: e
      }, () => {
        this.updateData();
      });
    }
  }

  render() {
    let getTTKH = this.props.keHoach || {};
    const isKiemTra = get(this.props, 'isKiemTra');
    let checkQD = false;
    if (getTTKH && getTTKH.keHoachDaCoQuyetDinh) {
      checkQD = true;
    }
    return (
      <section className='wrap-block'>
        <div className='row pl10 pr10'>
          { this.props.tabType == 'old' ?
              <h2 className='title-14 col-100 pt20 pl20 pr20 pb15'>1. Thông tin kế hoạch sửa đổi, bổ sung</h2>
            : checkQD ?
              <h2 className='title-14 p20'>1. Thông tin kế hoạch</h2>
            :
              <h2 className='title-14 col-100 pt20 pl20 pr20 pb15'>1. Thông tin kế hoạch thêm mới</h2>
          }
        </div>
        <ShowIf condition={checkQD}>
          <div className='row pl30 pr30'>
            <Text label={`Năm ${isKiemTra ? 'kiểm tra' : 'thanh tra'}:`} className='col-20' value={`Kế hoạch ${isKiemTra ? 'kiểm tra' : 'thanh tra'} năm ${getTTKH && getTTKH.data && getTTKH.data.namThanhTra ? getTTKH.data.namThanhTra : ''}`}/>
            <Text label="Quyết định phê duyệt KHTT:" className='col-20' value={getTTKH && getTTKH.data && getTTKH.data.quyetDinhPheDuyetKTTT ? getTTKH.data.quyetDinhPheDuyetKTTT : ''}/>
            <Text label="Ngày phê duyệt:" className='col-20' value={getTTKH && getTTKH.data && getTTKH.data.ngayRaQuyetDinh ? moment(getTTKH.data.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''}/>
          </div>
          <div className='mt10'>
            <div className='big-border'></div>
          </div>
          <section className='wrap-block'>
          <div className='row pl10 pr10'>
            <h2 className='title-14 p20'>2. Thông tin điều chỉnh</h2>
          </div>
            <div className='row pl30 pr30'>
              <Input className="col-25 mb10" label="Số văn bản" placeholder="Nhập..." value={this.state.soVanBanDieuChinh} onChange={this.onChange.bind(this, 'soVanBanDieuChinh')} name='soVanBanDieuChinh' bindValidator={this} channel='formTaoDon' require maxLength={255}/>
              <DatePicker className="col-25 mb10" label="Ngày quyết định" value={this.state.ngayQuyetDinhDieuChinh} onChange={this.handleChangeDate.bind(this, 'ngayQuyetDinhDieuChinh')} name='ngayQuyetDinhDieuChinh' bindValidator={this} channel='formTaoDon' require endDate={new Date()}/>
              <TextArea className="col-100 mb5" label="Lý do:" value={this.state.lyDoDieuChinh} onChange={this.onChange.bind(this, 'lyDoDieuChinh')} name='lyDoDieuChinh' bindValidator={this} channel='formTaoDon' require maxLength={1000}/>
            </div>
            <div className='row pl35 pr35'>
              <ContainerFileDinhKem loaiVanBanSuggest='VBDC' soVanBanSuggest={this.state.soVanBanDieuChinh} ngayQuyetDinhSuggest={this.state.ngayQuyetDinhDieuChinh} ref='containerFileDinhKem' name='fileDinhKemDon' label="Danh sách văn bản đính kèm" bindValidator={this} data={this.state.listTaiLieuVanThuThayTheCTT} disableTopLine={true} phanLoaiQuyTrinh="DIEU_CHINH_KE_HOACH_THANH_TRA" onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChangeDK.bind(this)}  allowExcelFile={true}/>
            </div>
          </section>
        </ShowIf>
        <ShowIf condition={!checkQD}>
        {
          this.props.isTTTW ?
          <div className='row pl25 pr25'>
            {
              (this.props.trangthaiKHTT === 'NHAP_KHTT_PHE_DUYET' || this.props.data.trangThaiKeHoachThanhTra === 'CHO_RA_QUYET_DINH') &&
              <Input className='col-input' label={this.props.tabType === 'old' ? 'Số quyết định SĐ, BS' : 'Quyết định phê duyệt KHTT'}  placeholder='Nhập...' require bindValidator={this} channel="formTaoDon" value={this.state.quyetDinhPheDuyetKTTT} onChange={this.onChange.bind(this, 'quyetDinhPheDuyetKTTT')} name='quyetDinhPheDuyetKTTT' maxLength={255}/>
            }
            {
              (this.props.trangthaiKHTT === 'NHAP_KHTT_PHE_DUYET' || this.props.data.trangThaiKeHoachThanhTra === 'CHO_RA_QUYET_DINH') &&
              <DatePicker className='col-input' label="Ngày phê duyệt" endDate={new Date()} bindValidator={this} require channel="formTaoDon" value={this.state.ngayRaQuyetDinh} onChange={ this.handleChangeDate.bind(this, 'ngayRaQuyetDinh')} name='ngayRaQuyetDinh'/>
            }
            {/* <ShowIf condition={this.props.tabType != 'old'}>
              <DropDown className='col-input' label='Năm thanh tra' options={this.props.namThanhTra} placeholder keyName="giaTri" valueName="ten" selectedValue={this.state.namThanhTra} onChange={this.onChange.bind(this, 'namThanhTra')} name='namThanhTra' bindValidator={this} require channel="formTaoDon"/>
            </ShowIf> */}

            <TextArea className='col-100' label={this.props.tabType === 'old' ? 'Lý do sửa đổi, bổ sung' : 'Tóm tắt kế hoạch'} bindValidator={this} require={this.props.tabType === 'old' ? true : false} channel="formTaoDon" value={this.state.ghiChu} onChange={this.onChange.bind(this, 'ghiChu')} name='ghiChu' rows={3} placeholder='Nhập...' maxLength={1000}/>
          </div>
          :
          <div className='row pl25 pr25'>
            {
              get(this.props.data, 'trangThaiKeHoachThanhTra') === 'CHO_RA_QUYET_DINH' &&
              <Input className='col-input' label={this.props.tabType === 'old' ? 'Số quyết định SĐ, BS' : 'Quyết định phê duyệt KHTT'}  placeholder='Nhập...' require bindValidator={this} channel="formTaoDon" value={this.state.quyetDinhPheDuyetKTTT} onChange={this.onChange.bind(this, 'quyetDinhPheDuyetKTTT')} name='quyetDinhPheDuyetKTTT' maxLength={255}/>
            }
            {
               get(this.props.data, 'trangThaiKeHoachThanhTra') === 'CHO_RA_QUYET_DINH' &&
              <DatePicker className='col-input' label="Ngày phê duyệt" endDate={new Date()} bindValidator={this} require channel="formTaoDon" value={this.state.ngayRaQuyetDinh} onChange={ this.handleChangeDate.bind(this, 'ngayRaQuyetDinh')} name='ngayRaQuyetDinh'/>
            }
            {/* <ShowIf condition={this.props.tabType != 'old'}>
              <DropDown className='col-input' label='Năm thanh tra' options={this.props.namThanhTra} placeholder keyName="giaTri" valueName="ten" selectedValue={this.state.namThanhTra} onChange={this.onChange.bind(this, 'namThanhTra')} name='namThanhTra' bindValidator={this} require channel="formTaoDon"/>
            </ShowIf> */}

            <TextArea className='col-100' label={this.props.tabType === 'old' ? 'Lý do sửa đổi, bổ sung' : 'Tóm tắt kế hoạch'} bindValidator={this} require={this.props.tabType == 'old' ? true : false} channel="formTaoDon" value={this.state.ghiChu} onChange={this.onChange.bind(this, 'ghiChu')} name='ghiChu' rows={3} placeholder='Nhập...' maxLength={1000}/>
          </div>
        }
        </ShowIf>

      </section>
    );
  }
}

ThongTinChung.defaultProps = {
  data: {},
  dataBS: {},
  namThanhTra: []
}

const mapStateToProps = state => ({
  namThanhTra: state.danhSachKHThanhTra.namThanhTra
});

export default connect(mapStateToProps)(validatable(ThongTinChung));




// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/sub-view/ThongTinChung.jsx